import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KTIcon, toAbsoluteUrl } from "../../../helpers";
import { useLayout } from "../../core";
import { HeaderToolbar } from "./HeaderToolbar";

import "../././../../../main.css";

export function HeaderWrapper() {
	const { config, classes, attributes } = useLayout();
	const { aside } = config;
	const [isMinimized, setIsMinimized] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < 992);
		window.addEventListener("resize", handleResize);

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.attributeName === "data-kt-aside-minimize") {
					setIsMinimized(
						document.body.getAttribute("data-kt-aside-minimize") === "on",
					);
				}
			});
		});
		observer.observe(document.body, { attributes: true });
		setIsMinimized(
			document.body.getAttribute("data-kt-aside-minimize") === "on",
		);

		return () => {
			window.removeEventListener("resize", handleResize);
			observer.disconnect();
		};
	}, []);

	return (
		<div
			id="kt_header"
			className={clsx(
				"header glass-effect",
				classes.header.join(" "),
				"align-items-stretch",
			)}
			style={{ zIndex: 105 }}
			{...attributes.headerMenu}
		>
			{/* begin::Brand */}
			<div
				className={`header-brand p-0 position-relative ${isMobile ? "d-flex justify-content-between pe-3 flex-grow-1" : ""}`}
				style={{
					transition: "width 0.4s ease",
					width: isMobile ? "auto" : isMinimized ? "85px" : "265px",
				}}
			>
				{/* begin::Logo Wrapper */}
				<div
					style={{ minWidth: 0 }}
					className={isMobile ? "flex-grow-1" : "w-100"}
				>
					<Link
						to="/dashboard"
						className="header-left "
						style={{ width: "100%" }}
					>
						{!isMinimized && (
							<div
								className="brand-emblem d-none d-lg-flex align-items-center gap-2 ps-1"
								style={{
									opacity: isMinimized ? 0 : 1,
									transition: "all 0.4s ease",
								}}
							>
								<img
									src={toAbsoluteUrl("media/logos/Tamil_Nadu_Emblem.png")}
									alt="TN Government Emblem"
									style={{
										height: "38px",
										width: "auto",
										backgroundColor: "white",
										borderRadius: "5px",
										padding: "2px 3px",
										objectFit: "contain",
										boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
										flexShrink: 0,
									}}
								/>
								<div className="d-flex flex-column text-start overflow-hidden" style={{ lineHeight: 1.15 }}>
									<span
										className="text-white fw-bolder text-truncate"
										style={{
											fontSize: "11.5px",
											letterSpacing: "0px",
											fontFamily: "Georgia, 'Times New Roman', serif",
										}}
									>
										Social Audit Unit of Tamil Nadu
									</span>
									<span
										className="text-white-50 text-truncate mt-1"
										style={{
											fontSize: "9px",
											fontWeight: 500,
										}}
									>
										Rural Development &amp; Panchayat Raj Dept.
									</span>
								</div>
							</div>
						)}
						{/* Small logo for minimized desktop */}
						<img
							src={toAbsoluteUrl("media/logos/Tamil_Nadu_Emblem.png")}
							alt="TN Government Emblem"
							className="brand-emblem d-none d-lg-block"
							style={{
								display: isMinimized ? "block" : "none",
								opacity: isMinimized ? 1 : 0,
								maxWidth: isMinimized ? "60px" : "0px",
								margin: isMinimized ? undefined : "0",
								padding: isMinimized ? "2px" : "0",
								transform: isMinimized ? "scale(1)" : "scale(0.5)",
								backgroundColor: "white",
								borderRadius: "5px",
								height: "40px",
								objectFit: "contain",
								transition: "all 0.4s ease",
								transformOrigin: "left center",
							}}
						/>
						{/* Always show this icon on Mobile, replacing the large logo */}
						<div className="d-flex d-lg-none align-items-center gap-3">
							<img
								src={toAbsoluteUrl("media/logos/Tamil_Nadu_Emblem.png")}
								alt="TN Government Emblem"
								className="brand-emblem bg-white p-1 rounded"
								style={{
									height: "40px",
									objectFit: "contain",
								}}
							/>
							<div className="d-flex flex-column text-start overflow-hidden">
								<span className="text-white fw-bold fs-6 text-truncate">
									Social Audit Unit of Tamil Nadu
								</span>
								<span className="text-white-50 fs-9 text-truncate">
									Rural Development &amp; Panchayat Raj Department
								</span>
							</div>
						</div>
					</Link>
				</div>
				{/* end::Logo Wrapper */}

				{aside.minimize && (
					<div
						id="kt_aside_toggle"
						className="btn btn-icon w-35px h-35px aside-minimize d-none d-lg-flex align-items-center justify-content-center"
						data-kt-toggle="true"
						data-kt-toggle-state="active"
						data-kt-toggle-target="body"
						data-kt-toggle-name="aside-minimize"
						style={{
							position: "absolute",
							right: "-17px",
							bottom: "-17px", // position at bottom
							zIndex: 99999, // Ensure it is above the aside which may have z-index ~100+
							background: "rgba(19, 28, 93, 0.8)", // Solid dark primary brand blue for visibility
							border: "2px solid rgba(255, 255, 255, 0.8)", // bright white border
							borderRadius: "10px",
							backdropFilter: "blur(4px)",
							boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.4)",
							cursor: "pointer",
							transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.background = "rgba(19, 28, 93, 1)";
							e.currentTarget.style.boxShadow =
								"0 6px 12px -2px rgba(0, 0, 0, 0.5)";
							e.currentTarget.style.transform = "translateY(-2px) scale(1.05)";
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.background = "rgba(19, 28, 93, 0.8)";
							e.currentTarget.style.boxShadow =
								"0 4px 6px -1px rgba(0, 0, 0, 0.4)";
							e.currentTarget.style.transform = "translateY(0) scale(1)";
						}}
					>
						<span
							style={{
								transition: "transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
								display: "inline-flex",
								transform: isMinimized ? "rotateY(180deg)" : "rotateY(0deg)",
							}}
						>
							<KTIcon iconName="arrow-left" className="fs-2 text-white" />
						</span>
					</div>
				)}

				{/* begin::Aside mobile toggle */}
				<div
					className="d-flex align-items-center d-lg-none ms-n3 me-1"
					title="Show aside menu"
				>
					<div
						className="btn btn-icon btn-active-color-primary w-30px h-30px"
						id="kt_aside_mobile_toggle"
					>
						<KTIcon iconName="abstract-14" className="fs-1 text-white" />
					</div>
				</div>
				{/* end::Aside mobile toggle */}
			</div>
			{/* end::Brand */}
			<HeaderToolbar />
		</div>
	);
}
